"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.template = void 0;
const _ = __importStar(require("lodash"));
const handlebars_1 = __importDefault(require("handlebars"));
handlebars_1.default.registerHelper('eq', function (a, b) {
    return a == b;
});
handlebars_1.default.registerHelper('neq', function (a, b) {
    return a != b;
});
let numberFilter;
handlebars_1.default.registerHelper('number', function (n) {
    if (n == null) {
        return '';
    }
    if (_.isUndefined(numberFilter)) {
        numberFilter = _.get(window, '$app.i18n.filters.number', false);
        if (!numberFilter) {
            console.warn('Missing number filter. ' +
                'Numbers will be not formatted within Handlebar templates.');
        }
    }
    if (numberFilter) {
        return numberFilter(n);
    }
    return n;
});
const interpolate = /{{([\s\S]+?)}}/g;
const normalizeFormat = (value) => {
    if (value.startsWith('#!')) {
        return value.substring(2);
    }
    return value;
};
function stripHtmlTags(input) {
    return (input
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim());
}
function template(opts) {
    if (opts.engine == 'hb') {
        return handlebarsTemplateFormatter(opts);
    }
    const textFormat = _.template(opts.format, { interpolate });
    function templateFormatter(row, cell, value, columnDef, data) {
        if (data) {
            return textFormat({
                $value: _.get(data, columnDef.field),
                ...data
            });
        }
        return '';
    }
    templateFormatter.exportDataFormatter = function (row, cell, value, columnDef, data) {
        return stripHtmlTags(templateFormatter(row, cell, value, columnDef, data) || '');
    };
    templateFormatter.filterFormattedValue = true;
    return templateFormatter;
}
exports.template = template;
function handlebarsTemplateFormatter(opts) {
    const template = handlebars_1.default.compile(normalizeFormat(opts.format));
    function templateFormatter(row, cell, value, columnDef, data) {
        if (data) {
            try {
                return template({
                    $value: _.get(data, columnDef.field),
                    ...data
                });
            }
            catch (err) {
                return `#ERROR ${err}`;
            }
        }
        return '';
    }
    templateFormatter.exportDataFormatter = function (row, cell, value, columnDef, data) {
        return stripHtmlTags(templateFormatter(row, cell, value, columnDef, data) || '');
    };
    templateFormatter.filterFormattedValue = true;
    return templateFormatter;
}
//# sourceMappingURL=template.js.map